import get from "just-safe-get";

export default {
    install: (Vue, options) => {
        const constants = {
            UserIntent: {
                values: {
                    CLIENT: { userType: "CLIENT", path: "employer" },
                    HRBP: { userType: "HRBP", path: null },
                    PAYROLL: { userType: "PAYROLL", path: null },
                    EE_MANAGER: { userType: "EE_MANAGER", path: null },
                    IT_SECURITY: { userType: "IT_SECURITY", path: null },
                    EMPLOYEE: { userType: "EMPLOYEE", path: "employee" },
                    AUTHENTICATED: { userType: "AUTHENTICATED", path: null },
                    GUEST: { userType: "GUEST", path: null },
                },

                getByUserType(userType) {
                    return this.values[Object.keys(this.values).find((key) => this.values[key].userType === userType)];
                },

                getByPath(path) {
                    return this.values[Object.keys(this.values).find((key) => this.values[key].path === path)];
                }
            },

            LoginRouteNames: {
                EMPLOYEE: 'loginEmployee',
                CLIENT: 'loginClient'
            },

            DateUnavailablePlaceholder: "TBD",

            HistoryContext: {
                WITH_PORTALFILE_HISTORY: "WITH_PORTALFILE_HISTORY",
                WITH_STREAMING_PORTALFILE_HISTORY: "WITH_STREAMING_PORTALFILE_HISTORY",
                WITH_PORTALFILE_STATECHANGE: "WITH_PORTALFILE_STATECHANGE",
                WITH_NOTIFICATION_HISTORY: "WITH_NOTIFICATION_HISTORY",
            },

            CASE_TYPE: {
                LEAVE: "LEAVE",
                ADA_AS_LEAVE: "ADA_AS_LEAVE",
                ADA_AT_WORK: "ADA_AT_WORK",
            },

            FILTER_STATUS_TO_STATUS: {
                ALL: ["Pending", "Approved", "Approved Done"],
                APPROVED: ["Approved", "Approved Done"],
                PENDING: ["Pending"],
            },

            REPORT_TYPE: {
                UPCOMING: "UPCOMING",
                RETURNING: "RETURNING",
                RECENT: "RECENT"
            },

            WEEKS_FOR_RETURNING_UPCOMING: 2,

            TAGS: {
                ER: {
                    id: 7,
                    code: "ER",
                    name: "Employer Only",
                    type: "CHECKLIST_PARAGRAPH",
                    category: "VIEW_PERMISSION"
                }
            },

            LEAVE_DETAIL_STATUS: {
                CANCELLED: {
                    id: 1,
                    name: "Cancelled"
                },
                APPROVED_DONE: {
                    id: 2,
                    name: "Approved Done"
                },
                APPROVED: {
                    id: 3,
                    name: "Approved"
                },
                PENDING: {
                    id: 4,
                    name: "Pending"
                },
                INFO_ONLY: {
                    id: 5,
                    name: "Info Only"
                },
                DENIED: {
                    id: 6,
                    name: "Denied"
                },
                OTHER: {
                    id: 7,
                    name: "Other"
                },
                APPROVED_FDA_NOT_CONFIRMED: {
                    id: 8,
                    name: "Approved but FDA Not Confirmed"
                },
                PENDING_FDA_NOT_CONFIRMED: {
                    id: 9,
                    name: "Pending and FDA Not Confirmed"
                },
                NEW: {
                    id: 10,
                    name: "New"
                }
            },

            LEAVE_DETAIL_SUBSTATUS: {
                EE_SUBMISSION: { code: "EE_SUBMISSION", name: "Employee Submission", state: "WAITING_FOR_EE" },
                EE_ADMIN_REVIEW: { code: "EE_ADMIN_REVIEW", name: "Employee Admin Review", state: "WAITING_FOR_ADMIN" },
                ER_REVIEW: { code: "ER_REVIEW", name: "Employer Review", state: "WAITING_FOR_ER" },
                ER_ADMIN_REVIEW: { code: "ER_ADMIN_REVIEW", name: "Employer Admin Review", state: "WAITING_FOR_ADMIN" }
            },

            ITEM_TYPES: {
                DOCUMENTS_TO_SUBMIT: { id: 1, name: "Documents that the client EE needs to complete." },
                TASKS_TO_COMPLETE: { id: 2, name: "Items that the client EE needs to confirm as understood." },
                RESOURCES_AND_REMINDERS: { id: 3, name: "Items that are informational only with no actions" }
            },

            ITEM_STATUSES: {
                NONE: { code: "NONE", name: "None" , state: "None"},
                COMPLETED: { code: "COMPLETED", name: "Completed", state: "COMPLETED" },
                FORM_PENDING_CLIENT: { code: "FORM_PENDING_CLIENT", name: "Form Pending Employee", state: "WAITING_FOR_EE" },
                FORM_PENDING_LARKIN: { code: "FORM_PENDING_LARKIN", name: "Form Pending Larkin", state: "WAITING_FOR_ADMIN" },
                FORM_COMPLETED: { code: "FORM_COMPLETED", name: "Form Completed", state: "COMPLETED" },
                PENDING_CLIENT: { code: "PENDING_CLIENT", name: "Pending Employee", state: "WAITING_FOR_EE" },
                PENDING_LARKIN: { code: "PENDING_LARKIN", name: "Pending Larkin", state: "WAITING_FOR_ADMIN" },
                UPLOAD_PENDING_LARKIN: { code: "UPLOAD_PENDING_LARKIN", name: "Upload Pending Larkin", state: "WAITING_FOR_ADMIN" },
                UPLOAD_PENDING_CLIENT: { code: "UPLOAD_PENDING_CLIENT", name: "Upload Pending Employee", state: "WAITING_FOR_EE" },
                UPLOAD_COMPLETED: { code: "UPLOAD_COMPLETED", name: "Upload Completed", state: "COMPLETED" },
                ERUPLOAD_PENDING_LARKIN: { code: "ERUPLOAD_PENDING_LARKIN", name: "Upload Pending Larkin", state: "WAITING_FOR_ADMIN" },
                ERUPLOAD_PENDING_EMPLOYER: { code: "ERUPLOAD_PENDING_EMPLOYER", name: "Upload Pending Employer", state: "WAITING_FOR_ER" },
                ERUPLOAD_COMPLETED: { code: "ERUPLOAD_COMPLETED", name: "Upload Completed", state: "COMPLETED" },
                WORKFLOW_PENDING_CLIENT: { code: "WORKFLOW_PENDING_CLIENT", name: "Workflow Pending Employee", state: "WAITING_FOR_EE" },
                WORKFLOW_STARTED: { code: "WORKFLOW_STARTED", name: "Workflow Started", state: "WAITING_FOR_EE" },
                WORKFLOW_PENDING_LARKIN: { code: "WORKFLOW_PENDING_LARKIN", name: "Workflow Pending Larkin", state: "WAITING_FOR_ADMIN" },
                WORKFLOW_COMPLETED: { code: "WORKFLOW_COMPLETED", name: "Workflow Completed", state: "COMPLETED" }
            },

            ITEM_STATES: {
                NONE: {
                    code: "NONE",
                    name: "None",
                    class: "badge-secondary"
                },
                WAITING_FOR_ER: {
                    code: "WAITING_FOR_ER",
                    name: "Waiting for Employer",
                    class: "badge-waiting-for-er"
                },
                WAITING_FOR_EE: {
                    code: "WAITING_FOR_EE",
                    name: "Waiting for Employee",
                    class: "badge-waiting-for-ee"
                },
                WAITING_FOR_ADMIN: {
                    code: "WAITING_FOR_ADMIN",
                    name: "Waiting for Admin",
                    class: "badge-waiting-for-admin"
                },
                APPROVED: {
                    code: "APPROVED",
                    name: "Approved",
                    class: "badge-approved"
                },
                COMPLETED: {
                    code: "COMPLETE",
                    name: "Complete",
                    class: "badge-completed"
                }
            }
        };

        constants.ADA_CASE_TYPES = [
            constants.CASE_TYPE.ADA_AT_WORK,
            constants.CASE_TYPE.ADA_AS_LEAVE,
        ];

        Vue.prototype.$constants = constants;
    }
};